export class MonthlyStats {
  public static readonly ALL_DATA = "all";
  public static readonly CONFIRM_STATUS_LAST_DAY = 6;
  public static readonly ALL_MONTHS_DATA = 'All Months'
}
